export default function translate(s) {
  const splits = s.replace(/([A-Z])/g, " $1").trim();

  return splits.charAt(0).toUpperCase() + splits.slice(1);
}
